import { createAction, createRequestActions } from "common/helpers/action";

export const initKkmTransactionList = createRequestActions("KKM.TRANSACTION_LIST.INIT");
export const scrollKkmTransactionList = createRequestActions("KKM.TRANSACTION_LIST.SCROLL");
export const searchKkmTransactionList = createRequestActions("KKM.TRANSACTION_LIST.SEARCH");
export const filterKkmTransactionList = createRequestActions("KKM.TRANSACTION_LIST.FILTER");
export const sortKkmTransactionList = createRequestActions("KKM.TRANSACTION_LIST.SORT");

export const showDetailKkmTransactionList = createAction("KKM.TRANSACTION_LIST.SHOW_DETAIL");
